import { translate } from "@/plugins/i18n";
import type BaseEnumType from "../../baseEnumType";
import Key from "@/app/types/common/key";
import { Maybe } from "@/components/utils/typeHelpers";


export class EnumVesselMovementTargetType implements BaseEnumType {
  private static allValues: EnumVesselMovementTargetType[] = []; // make sure this is top-most
  
  public static drain = new EnumVesselMovementTargetType(0, "Drain", "enum_vessel_movement_target_type_drain");
  public static vessel = new EnumVesselMovementTargetType(1, "Vessel", "enum_vessel_movement_target_type_vessel");
  public static output = new EnumVesselMovementTargetType(2, "Output", "enum_vessel_movement_target_type_output");
  
  public key: number;
  public value: string;
  public translationKey: string;

  private constructor(key: number, value: string, translationKey: string) {
    this.key = key;
    this.value = value;
    this.translationKey = translationKey;
    EnumVesselMovementTargetType.allValues.push(this);
  }

  public get translation() { return translate(Key.fromString(this.translationKey)); }

  public isDrain() { return this === EnumVesselMovementTargetType.drain; }
  public isVessel() { return this === EnumVesselMovementTargetType.vessel; }
  public isOutput() { return this === EnumVesselMovementTargetType.output; }

  public static getValues(): readonly EnumVesselMovementTargetType[] {
    return EnumVesselMovementTargetType.allValues;
  }

  public static getValuesExcept0(): readonly EnumVesselMovementTargetType[] {
    return EnumVesselMovementTargetType.allValues.filter((x) => x.key !== 0);
  }

  public static getByKey(key: number): EnumVesselMovementTargetType {
    const found = EnumVesselMovementTargetType.allValues.find(e => e.key === key);
    if (found === undefined) {
      throw new Error(`EnumVesselMovementTargetType - Key not found: ${ key }`);
    }

    return found;
  }

  public static getByValue(name: string, def?: EnumVesselMovementTargetType): EnumVesselMovementTargetType {
    const found = name ? EnumVesselMovementTargetType.allValues.find(e => e.value.toLowerCase() === name.toLowerCase()) : null;
    if (!found) {
      if (def) {
        return def;
      }
      throw new Error(`EnumVesselMovementTargetType - Value not found: ${ name }`);
    }

    return found;
  }

  public equals(other: Maybe<EnumVesselMovementTargetType>): boolean {
    return this.key === other?.key;
  }
}